(() => {
  // src/lib/upsell-debug.ts
  var isUpsellDebug = () => {
    var _a;
    if ((_a = window.HotelCollection) == null ? void 0 : _a.debugRecommendations) return true;
    try {
      return new URLSearchParams(window.location.search).get("rebuy_debug") === "1";
    } catch (e) {
      return false;
    }
  };

  // src/lib/compare-at-price.ts
  var computeCompareAtDiscount = (compareAtCents, priceCents) => {
    if (compareAtCents <= 0 || compareAtCents <= priceCents) return 0;
    return Math.round((compareAtCents - priceCents) / compareAtCents * 100);
  };
  var syncCompareAtInputs = (container, compareAtCents, priceCents) => {
    const capInput = container.querySelector(
      "[data-compare-at-price-input]"
    );
    const discInput = container.querySelector(
      "[data-compare-at-price-discount-input]"
    );
    if (capInput) capInput.value = String(compareAtCents || 0);
    if (discInput)
      discInput.value = String(computeCompareAtDiscount(compareAtCents, priceCents));
  };

  // src/lib/upsell-price.ts
  var formatUpsellMoney = (cents) => {
    var _a;
    const fmt = ((_a = window.Shopify) == null ? void 0 : _a.money_format) || "${{amount}}";
    return fmt.replace("{{amount}}", (cents / 100).toFixed(2)).replace("{{amount_no_decimals}}", String(Math.floor(cents / 100)));
  };
  var upsellPlanPct = (card, planId) => {
    if (!planId) return 0;
    let pct = 0;
    (card.dataset.planDiscounts || "").split(";").forEach((pair) => {
      const [k, v] = pair.split("=");
      if (k === planId) pct = parseInt(v, 10) || 0;
    });
    return pct;
  };
  var syncUpsellPrice = (card) => {
    const priceEl = card.querySelector("[data-upsell-price]");
    if (!priceEl) return;
    const oncePrice = parseInt(card.dataset.oncePrice || "0", 10) || 0;
    const compareAt = parseInt(card.dataset.compareAt || "0", 10) || 0;
    const base = compareAt > 0 ? compareAt : oncePrice;
    const checkbox = card.querySelector("[data-subscribe-checkbox]");
    const planInput = card.querySelector("[data-selling-plan-input]");
    const freqInput = card.querySelector(
      '[data-subscription-frequency] input[name="selling_plan_choice"]'
    );
    const planId = checkbox && checkbox.checked ? freqInput && freqInput.value || planInput && planInput.dataset.sellingPlanId || "" : "";
    const pct = upsellPlanPct(card, planId);
    const price = pct > 0 ? Math.round(base * (100 - pct) / 100) : oncePrice;
    const strike = pct > 0 ? oncePrice > price ? oncePrice : 0 : base > price ? base : 0;
    priceEl.textContent = formatUpsellMoney(price);
    const compareEl = card.querySelector("[data-upsell-compare-price]");
    if (compareEl) {
      compareEl.textContent = strike ? formatUpsellMoney(strike) : "";
      compareEl.hidden = !strike;
    }
    const capInput = card.querySelector("[data-compare-at-price-input]");
    const discInput = card.querySelector("[data-compare-at-price-discount-input]");
    const onceDiscount = parseInt(card.dataset.onceDiscount || "0", 10) || 0;
    if (capInput) capInput.value = String(pct > 0 ? base : compareAt);
    if (discInput) discInput.value = String(pct > 0 ? pct : onceDiscount);
  };

  // src/lib/upsell-swatch.ts
  var syncUpsellSwatch = (swatch) => {
    const card = swatch.closest(".cart-item-upsell");
    if (!card) return;
    const variantId = swatch.dataset.variantId;
    if (variantId) {
      const idInput = card.querySelector('input[name="id"]');
      if (idInput) idInput.value = variantId;
    }
    const compareAt = parseInt(swatch.dataset.variantCompareAtPrice || "0", 10);
    const price = parseInt(swatch.dataset.variantPrice || "0", 10);
    const form = card.querySelector("form");
    if (form) syncCompareAtInputs(form, compareAt, price);
    card.dataset.oncePrice = String(price || 0);
    card.dataset.compareAt = String(compareAt > 0 ? compareAt : price || 0);
    const image = swatch.dataset.image;
    if (image) {
      const img = card.querySelector(".cart-item-upsell__image");
      if (img) img.src = image;
    }
    const variantTitle = swatch.dataset.variantTitle;
    if (variantTitle) {
      const variantEl = card.querySelector(".cart-item-upsell__variant");
      if (variantEl) variantEl.textContent = variantTitle === "Default Title" ? "" : variantTitle;
    }
    card.querySelectorAll("[data-color-swatch]").forEach((s) => s.classList.remove("color-swatch__item--selected"));
    swatch.classList.add("color-swatch__item--selected");
    syncUpsellPrice(card);
  };

  // src/pdp-upsell-popup.ts
  (() => {
    var _a;
    const LOG = "[pdp-popup]";
    const debug = isUpsellDebug();
    const log = (...args) => {
      if (debug) console.log(LOG, ...args);
    };
    const DEFAULT_LIMIT = 8;
    const DEFAULT_INTENT = "pdp";
    const dialog = document.querySelector(
      "dialog[data-pdp-upsell-popup]:not([data-init])"
    );
    if (!dialog) return;
    dialog.dataset.init = "true";
    const block = dialog.querySelector("[data-cart-upsell-block]");
    const target = dialog.querySelector("[data-pdp-upsell-target]");
    const titleEl = dialog.querySelector("[data-pdp-upsell-title]");
    const superTitleEl = dialog.querySelector("[data-pdp-upsell-super-title]");
    const descriptionEl = dialog.querySelector("[data-pdp-upsell-description]");
    const setHeading = (el, value) => {
      if (!el) return;
      if (value) {
        el.textContent = value;
        el.hidden = false;
      } else {
        el.textContent = "";
        el.hidden = true;
      }
    };
    const renderDebugNote = (result) => {
      const inner = dialog.querySelector(".pdp-upsell-popup__inner");
      if (!inner) return;
      const existing = inner.querySelector(".pdp-upsell-popup__debug");
      if (!debug) {
        if (existing) existing.remove();
        return;
      }
      const note = existing || document.createElement("div");
      note.className = "pdp-upsell-popup__debug";
      const meta = (result && result.meta) || {};
      const heading = (v) => typeof v === "string" && v.trim() ? v : "(none returned)";
      const rows = [
        ["placement", `pdp-popup / ${intent}`],
        ["datasource (markup)", sourceId || "(empty — metafield unset)"],
        ["datasource (used)", meta.sourceId || "(default endpoint — no ruleset)"],
        ["type", meta.recommendationType || "—"],
        ["provider", meta.providerUsed || "—"],
        ["fallback", meta.fellBack ? "yes" : "no"],
        ["title", heading(result && result.title)],
        ["super_title", heading(result && result.superTitle)],
        ["description", heading(result && result.description)],
        ["rendered", String(meta.renderedCount != null ? meta.renderedCount : "—")]
      ];
      note.textContent = rows.map(([k, v]) => `${k}: ${v}`).join("  \xB7  ");
      if (!existing) inner.insertBefore(note, inner.firstChild);
    };
    const productId = dialog.dataset.productId || "";
    const intent = dialog.dataset.intent || DEFAULT_INTENT;
    const limit = Number((_a = dialog.dataset.limit) != null ? _a : DEFAULT_LIMIT) || DEFAULT_LIMIT;
    const sourceId = (block == null ? void 0 : block.dataset.sourceId) || "";
    const slidesPerView = dialog.dataset.slidesPerView || "";
    const slidesPerViewTablet = dialog.dataset.slidesPerViewTablet || "";
    const slidesPerViewMobile = dialog.dataset.slidesPerViewMobile || "";
    log("PDP product detected", { productId, intent, sourceId, limit });
    let isOpen = false;
    const setState = (state) => {
      dialog.dataset.state = state;
    };
    const close = () => {
      if (dialog.open) dialog.close();
    };
    dialog.addEventListener("close", () => {
      isOpen = false;
      setState("loading");
      if (target) target.innerHTML = "";
      log("popup closed");
    });
    dialog.addEventListener("click", (e) => {
      const el = e.target;
      if (el === dialog || el.closest("[data-pdp-upsell-close]")) {
        close();
        return;
      }
      const swatch = el.closest(".cart-item-upsell [data-color-swatch]");
      if (swatch) {
        syncUpsellSwatch(swatch);
        return;
      }
      if (el.closest('button[type="submit"], [data-quick-add]')) {
        log("recommended product add-to-cart clicked");
      }
    });
    const loadRecs = async (variantId) => {
      var _a2, _b, _c, _d, _e, _f, _g;
      const engine = (_a2 = window.HotelCollection) == null ? void 0 : _a2.RecommendationEngine;
      if (!engine || !productId) {
        log("no engine or productId \u2014 cannot load");
        setState("empty");
        return false;
      }
      setState("loading");
      log("Rebuy datasource request started", { sourceId, intent, limit, variantId });
      try {
        const result = await engine.fetchHtml({ productId, variantId, limit, intent, sourceId });
        log("Rebuy response received", result.meta);
        renderDebugNote(result);
        if (!result.html || !target) {
          setState("empty");
          return false;
        }
        const tpl = document.createElement("template");
        tpl.innerHTML = result.html;
        if (slidesPerView || slidesPerViewTablet || slidesPerViewMobile) {
          const carouselEl = tpl.content.querySelector("carousel-el");
          if (carouselEl) {
            if (slidesPerViewMobile) carouselEl.setAttribute("data-slides-per-view", slidesPerViewMobile);
            if (slidesPerViewTablet) carouselEl.setAttribute("data-slides-per-view-md", slidesPerViewTablet);
            if (slidesPerView) carouselEl.setAttribute("data-slides-per-view-lg", slidesPerView);
          }
        }
        target.innerHTML = "";
        target.appendChild(tpl.content);
        if (block) block.dataset.provider = (_d = (_c = result.meta) == null ? void 0 : _c.providerUsed) != null ? _d : "";
        if (titleEl && result.title) titleEl.textContent = result.title;
        setHeading(superTitleEl, result.superTitle);
        setHeading(descriptionEl, result.description);
        setState("ready");
        log("products rendered", {
          renderedCount: (_e = result.meta) == null ? void 0 : _e.renderedCount,
          provider: (_f = result.meta) == null ? void 0 : _f.providerUsed,
          sourceId: (_g = result.meta) == null ? void 0 : _g.sourceId
        });
        return true;
      } catch (err) {
        log("Rebuy request failed", err);
        setState("error");
        return false;
      }
    };
    const open = async (variantId) => {
      if (isOpen || dialog.open) return;
      isOpen = true;
      setState("loading");
      dialog.showModal();
      const ok = await loadRecs(variantId);
      if (!ok) {
        log("no recommendations \u2014 closing popup");
        close();
      }
    };
    document.addEventListener("cart:item-added", (e) => {
      const detail = e.detail;
      if (detail == null ? void 0 : detail.isUpsell) {
        if (isOpen) {
          log("recommended product added successfully", { variantId: detail.variantId });
          close();
        }
        return;
      }
      log("add-to-cart success detected", { variantId: detail == null ? void 0 : detail.variantId });
      void open(detail == null ? void 0 : detail.variantId);
    });
  })();
})();
